import React, { useRef, useState, useEffect } from 'react';
import { saveUser, resetUserPassword } from '../../../services/UsersService';
import SelectLimit from './SelectLimit';
import SwitchInput from '../../../components/SwitchInput/SwitchInput';
import { useIntl } from 'react-intl';
import logger from '../../../utils/logger';

/**
 * props:
 * - data
 * - onSubmit
 */
function UserModal(props) {

    const { formatMessage } = useIntl();
    const t = (id) => formatMessage({ id });

    const DEFAULT_USER = {
        name: '',
        email: '',
        password: '',
        limitId: 0,
        telegramChat: '',
        phone: '',
        isActive: false
    }

    const [error, setError] = useState('');
    const [user, setUser] = useState(DEFAULT_USER);
    const btnClose = useRef('');
    const btnSave = useRef('');

    function onSubmit(event) {
        saveUser(user.id, user)
            .then(result => {
                btnClose.current.click();
                if (props.onSubmit) props.onSubmit(result);
            })
            .catch(err => {
                logger.error(err.response ? err.response.data : err.message);
                setError(err.response ? err.response.data : err.message);
            })
    }

    function onResetClick(event) {
        resetUserPassword(user.id)
            .then(result => {
                btnClose.current.click();
                if (props.onSubmit) props.onSubmit(result);
            })
            .catch(err => {
                logger.error(err.response ? err.response.data : err.message);
                setError(err.response ? err.response.data : err.message);
            })
    }

    function onInputChange(event) {
        setUser(prevState => ({ ...prevState, [event.target.id]: event.target.value }));
    }

    useEffect(() => {
        setUser(props.data);
    }, [props.data.id])

    useEffect(() => {
        const modal = document.getElementById('modalUser');
        modal.addEventListener('hidden.bs.modal', (event) => {
            setUser({ ...DEFAULT_USER });
        })
    }, [])

    return (
        <div className="modal fade" id="modalUser" tabIndex="-1" role="dialog" aria-labelledby="modalTitleNotify" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <p className="modal-title" id="modalTitleNotify">{props.data.id ? t('users.editTitle') : t('users.newTitle')}</p>
                        <button ref={btnClose} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="form-group">
                            <div className="mb-3">
                                <label htmlFor="name">{t('common.name')}:</label>
                                <input type="text" id="name" className="form-control" onChange={onInputChange} value={user.name || ""} placeholder={t('users.fullName')} />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="email">{t('common.email')}:</label>
                                <input type="text" id="email" className="form-control" onChange={onInputChange} value={user.email || ""} placeholder="user@email.com" />
                            </div>
                            {/* .gh-grid: pairs of fields reflow to one column on a narrow
                                modal instead of being squeezed by col-md-6. */}
                            <div className="gh-grid gh-grid-wide mb-3">
                                <div className="form-group">
                                    <label htmlFor="phone">{t('users.phone')}</label>
                                    <input type="text" id="phone" className="form-control" onChange={onInputChange} value={user.phone || ""} placeholder="+5551123456789" />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="telegramChat">{t('users.telegramChat')} <a className="badge bg-secondary py-1" href="/telegram-chat" target="_blank" rel="noreferrer">?</a></label>
                                    <input type="text" id="telegramChat" className="form-control" onChange={onInputChange} value={user.telegramChat || ""} placeholder="123456789" />
                                </div>
                            </div>
                            <div className="gh-grid gh-grid-wide mb-3 align-items-end">
                                <div className="form-group">
                                    <label htmlFor="limit">{t('users.limit')}</label>
                                    <SelectLimit id={user.limitId} onChange={onInputChange} />
                                </div>
                                <div className="form-group">
                                    <SwitchInput id="isActive" text={t('users.isActive')} onChange={onInputChange} isChecked={user.isActive || false} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer flex-wrap gap-2">
                        {
                            error
                                ? <div className="alert alert-danger mt-1 py-1 w-100 mb-0 text-break">{error}</div>
                                : <React.Fragment></React.Fragment>
                        }
                        {
                            user.id > 0
                                ? <button type="button" className="btn btn-sm btn-secondary" onClick={onResetClick}>{t('users.resetPassword')}</button>
                                : <React.Fragment></React.Fragment>
                        }
                        <button ref={btnSave} type="button" className="btn btn-sm btn-primary" onClick={onSubmit}>{t('common.save')}</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UserModal;
